<template>
  <div>
    <div>
      <md-dialog :md-active.sync="showDialog">
        <md-dialog-title>以手機進行</md-dialog-title>
        <md-dialog-content>
          <md-tabs>
            <md-tab md-label="QR Code">
              <a :href="qrCodeURL">
                <qr-code :text="qrCodeURL"></qr-code>
              </a>
            </md-tab>
          </md-tabs>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showDialog = false">關閉</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
    <div class="md-layout md-gutter md-alignment-center-center">
      <div class="md-layout-item md-size-50">
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-checkbox v-model="inPerson">本人填寫</md-checkbox>
            <md-button class="md-raised md-primary" @click="showDialog = true">以手機進行</md-button>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>代表人名稱</label>
              <md-input :disabled="inPerson" v-model="submitter_name"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>關係</label>
              <md-input :disabled="inPerson" v-model="relationship"></md-input>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>個人（個人舒適度）</label>
            <slider :value="ors.personal" @update="value => {change({type: 'personal', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>人際（家庭、親密關係）</label>
            <slider :value="ors.interpersonal" @update="value => {change({type: 'interpersonal', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>社會（工作、學校、友誼）</label>
            <slider :value="ors.social" @update="value => {change({type: 'social', value})}"></slider>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <label>整體（整體幸福感）</label>
            <slider :value="ors.overall" @update="value => {change({type: 'overall', value})}"></slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/components/Shared/Slider'
import VueQRCodeComponent from 'vue-qrcode-component'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      showDialog: false
    }
  },
  props: ['recordID', 'patientID'],
  components: {
    Slider,
    'qr-code': VueQRCodeComponent
  },
  computed: {
    inPerson: {
      get () {
        return (this.submitter_name === null && this.relationship === null)
      },
      set (value) {
        if (value) {
          this.submitter_name = null
          this.relationship = null
        } else {
          this.submitter_name = ''
          this.relationship = ''
          // this.submitter_name = '' this.relationship = ''
        }
      }
    },
    submitter_name: {
      get () {
        return this.ors.submitter_name
      },
      set (value) {
        this.change({type: 'submitter_name', value})
      }
    },
    relationship: {
      get () {
        return this.ors.relationship
      },
      set (value) {
        this.change({type: 'relationship', value})
      }
    },
    ...mapState('ors', {
      ors: state => state.content
    }),
    qrCodeURL: function () {
      return `${window.location.protocol}//${window.location.host}/#/ors-test-patient/${this.patientID}/${this.recordID}`
    }
  },
  methods: {
    ...mapMutations('ors', {
      change: 'change'
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ORSTest/ORS.vue